import DashboardService from 'services/DashboardService';

export const getDashboardQuery = (id) => {
  return DashboardService.getDashboard(id);
};
